import React from "react";
import PropTypes from "prop-types";
import ElectricRangeGraph from "../CostsCharts/ElectricRangeGraph";
import { FormattedMessage } from "react-intl";

const ElectricRange = ({ cars, title }) => {
  if (!cars || cars.length === 0) return null;

  return (
    <section className="container">
      <div className="row">
        <div className="col-md-4 col-lg-4">
        </div>
        <div
          id="costs-chart-areas"
          aria-live="polite"
          aria-atomic="true"
          role="region"
          style={{ position: "absolute", top: "-9999px" }}
        >
          <span>
            <FormattedMessage
              id="results.updated"
              defaultMessage="Results have been updated as of "
              description="Results have been updated as of "
            />
            {new Date().toLocaleString()}.
          </span>
        </div>
        <div className="col-md-8 col-lg-8">
          <ElectricRangeGraph cars={cars} />
        </div>
      </div>
    </section>
  );
};

export default ElectricRange;

ElectricRange.propTypes = {
  cars: PropTypes.array,
  title: PropTypes.string,
};
